// extracted by mini-css-extract-plugin
export default {"btn":"Like_btn__ofuep","liked":"Like_liked__8Eeqi","unliked":"Like_unliked__S81dx"};